/**
 * G15. Память: 6 карточек из журнала (год в моно, текст записи), найти
 * 3 пары. При деменции карточки «плывут» (класс `drift`). Счастье +2 за
 * все три; иначе ничего плохого.
 */
import { t } from '@life/i18n';
import { MEMORY_HAPPINESS, type MemoryInput, type MemoryState } from '@life/minigames';
import type { MinigameScreenProps } from './types';
import { Pairs } from './ui/Pairs';

export function Memory({ state, onInput }: MinigameScreenProps<MemoryInput, MemoryState>) {
  return (
    <>
      <p class="hint">{t('ui.minigame.memory.rules', { n: state.pairs, h: MEMORY_HAPPINESS })}</p>
      {state.drift && <p class="hint">{t('ui.minigame.memory.drift')}</p>}
      <Pairs
        label={t('ui.minigame.memory.label')}
        cards={state.cards.map((c) => ({ pair: c.pair, text: t(c.key, c.params), meta: t('ui.minigame.memory.age', { age: c.age }) }))}
        pairs={state.pairs}
        drift={state.drift}
        onDone={(pairs) => onInput({ pairs })}
      />
    </>
  );
}
